export default __webpack_public_path__ + "static/media/1.c71ae607.png";